import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import { IconButton, Button } from '@mui/material';
import failed from "../../assets/images/icons/geen-locatie.svg";
import BasicModal from "../BasicModal/BasicModal";
import { useNavigate } from "react-router-dom";
import Close from '../../assets/images/icons/cross.svg?react';

const ErrorPopup = (props) => {
  const { open, message, children, customTitle } = props;
  const navigate = useNavigate();
  const [showErrorModal, setShowErrorModal] = React.useState(false);
  const [title, setTitle] = React.useState('Het versturen van de aanvraag is niet gelukt');

  const handleClose = () => {
    setShowErrorModal(false);
    navigate("/");
  };
  useEffect(() => {
    setShowErrorModal(open);
    if (customTitle) {
      setTitle(customTitle);
    }
  }, [props]);

  return (
    <BasicModal
      className="error-popup"
      handleClose={handleClose}
      open={showErrorModal}
    >
      <IconButton className="close-btn" onClick={() => handleClose()}>
        <Close/>
      </IconButton>
      <div className="error-popup-modal">
        <img alt="image" src={failed}/>
        <h4 className="relocation-modal-text">{title}</h4>
        <p>{message}</p>
        {children && <div className="error-popup-children">{children}</div>}
        <div className="button-container">
          <Button onClick={() => handleClose()}>Bericht sluiten</Button>
        </div>
      </div>
    </BasicModal>
  );
};

ErrorPopup.propTypes = {
  open: PropTypes.bool,
  customTitle: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.any,
};

export default ErrorPopup;